import Vue from 'Vue';

/**
 * ********************************************************************
 * standard import lines for every component. Importing the template
 * and the component specific style.
 * ********************************************************************
 */
import './dc-search.style.scss';
import template from './dc-search.template.htm';
/**
 * *********************************************************************
 */

export default Vue.component('dc-search', {
    template: template,
    props: {},
    data() {
        return {
            active: false
        };
    },
    computed: {
        keyword:{
            get(){
                return this.$store.getters.filters.keyword;
            },
            set(newValue){
                this.$store.commit('setKeyword',newValue);
            }
        }
    },
    created() {},
    mounted() {},
    methods: {
        activateForm(){
            console.log("activated");
            this.active = true;
        },
        deactivateForm(){
            console.log("deactivated");
            this.active = false;
        },
        updateKeyword: _.debounce(function(e) {
            console.log("search keyword updated");
            this.keyword = e.target.value;
        },400),
        clearKeyword(){
            this.keyword = null;
        }
    },
    events:{
        clickOutside(){
            this.deactivateForm();
        }
    },
    watch: {}
});